import api from 'api';

export const loadCurrencies = api('GET /api/io/filters/currency');
export const loadPaymentTerms = api('GET /api/io/filters/payment-terms');
export const loadExpenseTypes = api('GET /api/io/filters/expense-types');
export const loadActions = api('GET /api/io/filters/actions');
export const loadApprovers = api('GET /api/io/filters/approvers');
export const loadCreators = api('GET /api/io/filters/creators');
export const loadBusinessEntity = api('GET /api/io/filters/business-entity');
export const loadAgreementTypes = api('GET /api/io/filters/agreement-types');
export const loadStatuses = api('GET /api/io/filters/statuses');
export const loadOwners = api('GET /api/io/filters/owners');
export const loadCustomerCompanies = api(
  'GET /api/io/filters/customer-companies'
);
